import { $devModeEnabled } from 'stores/dev-mode';
import { useStore } from 'effector-react';

export const useDevModeEnabled = () => useStore($devModeEnabled);
